import { PillTone } from '../ui/StatusPill';
import i18n from '../../i18n/i18n-setup';

interface NamedMember {
  userId: string;
  name?: string;
  username?: string;
  stravaProfile?: { firstname?: string; lastname?: string } | null;
}

// Prefer the Strava full name, then display name, then username.
export const getMemberDisplayName = (member: NamedMember): string => {
  if (member.stravaProfile?.firstname && member.stravaProfile?.lastname) {
    return `${member.stravaProfile.firstname} ${member.stravaProfile.lastname}`;
  }
  return member.name || member.username || member.userId;
};

// Decimal min/km -> "5:42 /km"; N/A when there is no usable pace.
export const formatPaceLabel = (pace: number): string => {
  if (!pace || !isFinite(pace)) return i18n.t('teams:pace.notAvailable');
  let minutes = Math.floor(pace);
  let seconds = Math.round((pace - minutes) * 60);
  if (seconds === 60) {
    minutes += 1;
    seconds = 0;
  }
  return `${minutes}:${seconds.toString().padStart(2, '0')} /km`;
};

export const getContestStatus = (startAt: Date | string, endAt: Date | string): { label: string; tone: PillTone } => {
  const now = new Date();
  if (new Date(endAt) <= now) return { label: i18n.t('teams:status.ended'), tone: 'muted' };
  if (new Date(startAt) <= now) return { label: i18n.t('teams:status.active'), tone: 'success' };
  return { label: i18n.t('teams:status.upcoming'), tone: 'accent' };
};
